module.exports = __webpack_public_path__ + "static/team-cactus-43865d62d3831d41081a211cc5bd51d1.png";